import { getTplStateStore } from "./utils.js";
export function bindTemplateProxy(brick) {
  var _tplHostMetadata$prox;
  const {
    ref,
    runtimeContext,
    element
  } = brick;

  // Error recovering brick may have no runtimeContext.
  if (!ref || !runtimeContext.tplStateStoreId) {
    return;
  }
  const {
    hostBrick
  } = getTplStateStore(runtimeContext, "bindTemplateProxy");
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const tplHostMetadata = hostBrick.tplHostMetadata;
  tplHostMetadata.internalBricksByRef.set(ref, brick);
  const events = (_tplHostMetadata$prox = tplHostMetadata.proxy) === null || _tplHostMetadata$prox === void 0 ? void 0 : _tplHostMetadata$prox.events;
  if (events) {
    for (const [from, to] of Object.entries(events)) {
      if (to.ref === ref) {
        var _to$refEvent, _ref, _ref$$$proxyListeners;
        const listener = e => {
          if (e.bubbles) {
            e.stopPropagation();
          }
          hostBrick.element.dispatchEvent(new CustomEvent(from, {
            detail: e.detail,
            bubbles: e.bubbles,
            cancelable: e.cancelable,
            composed: e.composed
          }));
        };
        const eventType = (_to$refEvent = to.refEvent) !== null && _to$refEvent !== void 0 ? _to$refEvent : from;
        element.addEventListener(eventType, listener);
        (_ref$$$proxyListeners = (_ref = element).$$proxyListeners) !== null && _ref$$$proxyListeners !== void 0 ? _ref$$$proxyListeners : _ref.$$proxyListeners = [];
        element.$$proxyListeners.push([eventType, listener]);
      }
    }
  }
}
export function unbindTemplateProxy(brick) {
  const {
    ref,
    runtimeContext,
    element
  } = brick;
  if (!(runtimeContext !== null && runtimeContext !== void 0 && runtimeContext.tplStateStoreId) || !ref) {
    return;
  }
  const {
    hostBrick
  } = getTplStateStore(runtimeContext, "unbindTemplateProxy");
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const tplHostMetadata = hostBrick.tplHostMetadata;
  tplHostMetadata.internalBricksByRef.delete(ref);
  for (const [type, fn] of (_$$proxyListeners = element.$$proxyListeners) !== null && _$$proxyListeners !== void 0 ? _$$proxyListeners : []) {
    var _$$proxyListeners;
    element.removeEventListener(type, fn);
  }
  delete element.$$proxyListeners;
}
//# sourceMappingURL=bindTemplateProxy.js.map